export default function gallery() {
  const widgetName = 'gallery';
  const widgetOpts = galleryOpts;
  const $widget = $(`#${widgetName}`);

  const linkedImages = false;

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    textOverImage: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 12,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
        changeFormatCards(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      }

      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
